<input
  matInput
  preventSpace
  (blur)="blur()"
  (keyup)="keyup()"
  (keyup.enter)="keyup()"
  (input)="change()"
  [disabled]="disabled || readonly"
  [(ngModel)]="value"
  type="date"
  [placeholder]="placeholder"

/>
